module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZmlsbD0iIzAwYTFkZSIgZD0iTTAgMjU2aDUxMnYyNTZIMHoiLz4KICA8cGF0aCBmaWxsPSIjZWQyOTM5IiBkPSJNMCAwaDUxMnYyNTZIMHoiLz4KICA8cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAxNzAuNjY3aDUxMnYxNzAuNjY2SDB6Ii8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/lu.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/lu.svg
// module chunks = 0